export default class Competition {
  constructor (dataCompetitionSeason) {
    this.id = dataCompetitionSeason.id
    this.competitionId = dataCompetitionSeason.competitionId
    this.seasonId = dataCompetitionSeason.seasonId
    this.leagueId = dataCompetitionSeason.leagueId
    this.districtId = dataCompetitionSeason.districtId
    this.name = dataCompetitionSeason.name
    this.actionRealTime = dataCompetitionSeason.actionRealTime
  }
}
